import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from "framer-motion";
import PageTitle from "../../components/PageTitle";
import { CHARACTERS } from "./characterData";
import "./character.css";

const CharacterDetail = () => {
	const { id } = useParams<{ id: string }>();
	const character = CHARACTERS.find(char => char.id === id);

	if (!character) {
		return (
			<div className="characters-page">
				<PageTitle title="Character Not Found" />
				<div className="main">
					<h2>キャラクターが見つかりませんでした。</h2>
					<Link to="/character">一覧に戻る</Link>
				</div>
			</div>
		);
	}

	return (
		<div className="characters-page">
			<div className="profile-page-wrapper"></div>
			<PageTitle title={character.name} />

			<div className="main">
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					className="character-detail-container"
				>
					<div className="detail-header">
						
					</div>

					<div className="detail-content">
						<div className="detail-image-wrapper">
							<img src={character.image} alt={character.name} className="detail-img" />
						</div>

						<div className="detail-info">
							<span className="char-tile-ruby" style={{ color: character.color }}>{character.ruby}</span>
							<h1 className="char-tile-name" style={{ fontSize: '3rem', margin: '0.1rem 0' }}>{character.name}</h1>
							{character.debut && (
								<p className="char-debut" style={{ opacity: 0.8, fontSize: '0.9rem' }}>デビュー年 : {character.debut}</p>
							)}		

							<p className="char-description">
								{character.description || "説明文が設定されていません。"}
							</p>
							

							{character.tags && character.tags.length > 0 && (
								<div className="char-tags" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '1rem' }}>
									{character.tags.map(tag => (
										<span key={tag} style={{ background: 'rgba(255,255,255,0.15)', padding: '4px 12px', borderRadius: '20px', fontSize: '0.8rem' }}>#{tag}</span>
									))}
								</div>
							)}
						</div>
					</div>
				</motion.div>
			</div>
		</div>
	);
};

export default CharacterDetail;
